import { lazy, Suspense } from 'react';
const LiveView = lazy(() => import('./LiveView'));
export const ViewRoute = () => (
  <Suspense fallback={<div>View laden…</div>}>
    <LiveView />
  </Suspense>
);
